import React from 'react';

export const inlineNavigationStyle = (
  visible: boolean
): React.CSSProperties => ({
  display: visible ? 'flex' : 'none',
  position: 'relative',
  top: 'auto',
  transform: 'none',
  left: 'auto',
  right: 'auto',
});
